import MenuButton from "@/global/components/menu-button"
import "./index.less"
// 项目管理svg
import { ReactComponent as FileSvg } from './icons/project-manager/file-maneger.svg';
import { ReactComponent as SwitchSvg } from './icons/project-manager/switch.svg';
import { ReactComponent as SystemLogSvg } from './icons/project-manager/system-log.svg';
import { ReactComponent as SendDataSvg } from './icons/project-manager/send-data.svg';
import { ReactComponent as SendResultSvg } from './icons/project-manager/send-result.svg';
import { ReactComponent as UserManagerSvg } from './icons/project-manager/user-manager.svg';
import { ReactComponent as GenerateReportSvg } from './icons/project-manager/generate-report.svg';
// 几何svg
import { ReactComponent as PointSvg } from './icons/geometry/point.svg';
import { ReactComponent as CircleSvg } from './icons/geometry/circle.svg';
import { ReactComponent as ExtSolidSvg } from './icons/geometry/ext-solid.svg';
import { ReactComponent as LineSvg } from './icons/geometry/line.svg';
import { ReactComponent as RectangleSvg } from './icons/geometry/rectangle.svg';
import { ReactComponent as ResolveSvg } from './icons/geometry/resolve-solid.svg';
import { ReactComponent as PlineSvg } from './icons/geometry/pline.svg';
import { ReactComponent as RegionSvg } from './icons/geometry/region.svg';
// 建模svg
import { ReactComponent as StationSvg } from './icons/modeling/station.svg';
import { ReactComponent as RoofSlabSvg } from './icons/modeling/roof-slab.svg';
import { ReactComponent as ColumnSvg } from './icons/modeling/column.svg';
import { ReactComponent as EavesBoardSvg } from './icons/modeling/eaves-board.svg';
import { ReactComponent as GutterSvg } from './icons/modeling/gutter.svg';
import { ReactComponent as LampSvg } from './icons/modeling/lamp.svg';
import { ReactComponent as TreeSvg } from './icons/modeling/tree.svg';
import { ReactComponent as ComponentSvg } from './icons/modeling/component.svg';
import { ReactComponent as CompassSvg } from './icons/modeling/compass.svg';
// 监测对象svg
import { ReactComponent as SelectGutterSvg } from './icons/monitor-object/select-gutter.svg';
import { ReactComponent as SelectRoofSlabSvg } from './icons/monitor-object/select-roof-slab.svg';
import { ReactComponent as SelectWindLocationSvg } from './icons/monitor-object/select-wind-location.svg';
// 参数设计svg
import { ReactComponent as WarningLevelSvg } from './icons/param-design/warning.svg';
// 监测设备svg
import { ReactComponent as CameraSvg } from './icons/monitoring/camera.svg';
import { ReactComponent as DeviceListSvg } from './icons/monitoring/device-list.svg';
import { ReactComponent as WaterLevelGaugeSvg } from './icons/monitoring/water-level-gauge.svg';
import { ReactComponent as AnemoclinographSvg } from './icons/monitoring/anemoclinograph.svg';
import { ReactComponent as IPCSvg } from './icons/monitoring/ipc.svg';
import { ReactComponent as ExchangeBoardSvg } from './icons/monitoring/exchange-board.svg';
import { ReactComponent as SerialSvg } from './icons/monitoring/serial.svg';
import { ReactComponent as DvrSvg } from './icons/monitoring/dvr.svg';
import { ReactComponent as DataWireSvg } from './icons/monitoring/data-wire.svg';
import { ReactComponent as MatchSvg } from './icons/monitoring/match.svg';
import { ReactComponent as SensorTypeSvg } from './icons/monitoring/sensor-type.svg';
// 安装与测试svg
import { ReactComponent as UploadRecordSvg } from './icons/install-test/upload-record.svg';
import { ReactComponent as TestRecordSvg } from './icons/install-test/test-record.svg';
import { ReactComponent as TestSvg } from './icons/install-test/test.svg';
// 运维svg
import { ReactComponent as StartSvg } from './icons/devops/start.svg';
import { ReactComponent as StopSvg } from './icons/devops/stop.svg';
import { ReactComponent as ChangeSvg } from './icons/devops/change.svg';
import { ReactComponent as WarningSvg } from './icons/devops/warning.svg';

import { useContext, useEffect, useState } from "react";
import { SideStatus } from "@/global/store/side-store";
import { CommonTabbarContext, SideContext } from "@/App";
import { graphicStore } from "@/global/store/graphic-store";
import { findComponentByType } from "@/api/archi/conponent";
import { COMPONENT_TYPE } from "@/enums/component-type";
import { ARCHI_SUB_CONTROL } from "@/passets/archibase-engine/enums/archi-sub-control";
import { Component } from "@/global/interface/archi/component";
import { LayerType } from "@/enums/layer-type";
import { ModelBase } from "pytha"
import { ARCHIBASE_SINGAL } from "@/passets/archibase-engine/enums/archibase-singal";
import { addMonitorObject } from "@/api/monitor-object/monitor-object";
import { useParams } from "react-router-dom";
import TnMessage from "@/global/components/message";
import { MONITOR_OBJECT_COLOR } from "@/global/constant/monitor-object";
import { emitter } from "@/global/listeners";
import { Emit_Event } from "@/enums/emit-event";
import { getSpecialPrimitiveLayerUuid } from "@/global/utils/layer-utils";
import axios from "axios";
import { getProjectDetail } from "@/api/project-manage/project";
import { Project } from "@/global/interface/project-manage/project";
import { startMonitoring, stopMonitoring, testDataBoxConnect, testSensorConnect } from "@/api/monitoring/monitoring";
import { message } from "antd";
import Icon from '@ant-design/icons';
import { MONITOR_OBJECT_TYPE } from "@/enums/monitor-object-type";
import { ARCHI_CTRL_TYPE } from "@/passets/archibase-engine/enums/archibase-control-type";
import { TAB_TYPE } from "@/enums/tab-type";
import { CommonTabbarState } from "@/global/components/common-tabbar";
import { getSensorByPrimitiveUuid, getSensors } from "@/api/device/sensor";
import { Sensor } from "@/global/interface/device/sensor";
import { DragModal } from "tncet-common";
import { getDataBoxByPrimitiveUuid, getDataBoxes } from "@/api/device/data-box";
import { DataBox } from "@/global/interface/device/data-box";
import { addTotalTestHistory } from "@/api/device/device";
import { DeviceTotalTestConnectHistory } from "@/global/interface/device/device";
import ReplaceModal from "./replace-modal";
import UploadRecordModal from "./upload-record-modal";
import AddSensorMarkingModal from "./add-sensor-marking";

export default function MenuPanel() {
    const { projectId } = useParams()

    // 侧边栏上下文
    const sideContext = useContext<SideStatus>(SideContext);
    // 导航
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文
    // 项目
    const [project, setProject] = useState<Project>();
    // 监测启停loading
    const [monitoringActionLoading, setMonitoringActionLoading] = useState<boolean>(false);
    // 测试进度弹窗显隐
    const [testModalVisible, setTestModalVisible] = useState<boolean>(false)
    // 测试总进度
    const [percent, setPercent] = useState<number>(0)
    // 上传记录弹窗
    const [uploadRecordVisible, setUploadRecordVisible] = useState<boolean>(false)
    const [uploadSensor, setUploadSensor] = useState<Sensor>(null)
    const [uploadDataBox, setUploadDataBox] = useState<DataBox>(null)
    // 更换弹窗
    const [changeModalVisible, setChangeModalVisible] = useState<boolean>(false)
    const [changeSensor, setChangeSensor] = useState<Sensor>(null)
    const [changeDataBox, setChangeDataBox] = useState<DataBox>(null)
    const [visiable, setVisiable] = useState<boolean>(false); // 传感器选型弹窗

    useEffect(() => {
        if (isNaN(+projectId)) return;
        getProjectDetail(+projectId).then(res => {
            let project = res.data;
            setProject(project);
        })
    }, [projectId])

    const onMenuButtonClick = (menuName: string) => {
        sideContext.setSelectedPanelValue(menuName)
    }

    const onActiveSubControl = (cmd: string) => {
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(cmd);
    }

    const selectMonitorObject = (cmd: string) => {
        graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).add(onSelectMonitorObjectFinish);
        onActiveSubControl(cmd)
    }

    const onSelectMonitorObjectFinish = (entity: ModelBase) => {
        let cmd = graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl;
        let objectName = "监测对象";
        let objectType = MONITOR_OBJECT_TYPE.ROOF_SLAP;
        if (cmd != null) {
            if (cmd.id == ARCHI_CTRL_TYPE.ADD_GUTTER_MONITOR_OBJECR) {
                // 天沟
                objectName = "天沟";
                objectType = MONITOR_OBJECT_TYPE.GUTTER;
            } else if (cmd.id == ARCHI_CTRL_TYPE.ADD_ROOF_SLAP_MONITOR_OBJECR) {
                // 屋面板
                objectName = "屋面板";
                objectType = MONITOR_OBJECT_TYPE.ROOF_SLAP;
            } else if (cmd.id == ARCHI_CTRL_TYPE.ADD_WIND_LOCATION_MONITOR_OBJECR) {
                // 风位
                objectName = "风位";
                objectType = MONITOR_OBJECT_TYPE.WIND_LOCATION;
            }
        }
        if (!entity) {
            graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).remove(onSelectMonitorObjectFinish);
            return;
        }
        graphicStore.extraContext.getCurrentViewEditor().addObject(entity);
        entity.changeColor(MONITOR_OBJECT_COLOR, false);
        entity.needRedraw = true;
        graphicStore.extraContext.listeners.signals.needRender.dispatch('redraw');
        // 添加监测对象
        let data = {
            name: objectName,
            type: objectType,
            entityJson: entity.toJson(),
        }
        addMonitorObject(+projectId, data).then(res => {
            TnMessage.success("定义监测对象成功");
            let object = {
                ...data,
                id: res.data,
                entityUuid: entity.uuid,
            }
            emitter.emit(Emit_Event.ADD_MONITOR_OBJECT_FINISH, object);
        }).catch(err => {
            console.log(err)
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("定义监测对象失败");
            }
        }).finally(() => {
            graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).remove(onSelectMonitorObjectFinish);
        })
    }

    const onAssembleComponentClick = (componentType: string, layerType: number) => {
        let promiseList = [];
        promiseList.push(() => findComponentByType(componentType));
        promiseList.push(() => getSpecialPrimitiveLayerUuid(projectId, layerType));

        axios.all(promiseList?.map(fn => fn())).then(res => {
            let component: Component = res[0].data || null
            console.log('component', component)
            let entities: ModelBase[] = []
            for (let i = 0; i < component?.entities?.length; i++) {
                let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(component.entities[i].type))();
                entity.fromJson(component.entities[i]);
                entities.push(entity)
            }
            let layerUuid: string = res[1];
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(ARCHI_SUB_CONTROL.ADDBUILDINGCOMPONENTCONTROL.name);
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.setInitControlData.dispatch(
                {
                    type: componentType,
                    entities: entities,
                    position: component.position,
                    layerUuid: layerUuid,
                }
            );
        })
    }

    const onStartClick = () => {
        if (monitoringActionLoading) return;
        setMonitoringActionLoading(true)
        startMonitoring(+projectId).then(res => {
            setProject({
                ...project,
                working: true,
            })
            if (!!res.data) {
                message.success('成功启动监测');
            }
        }).finally(() => {
            setMonitoringActionLoading(false);
        })
    }

    const onStopClick = () => {
        if (monitoringActionLoading) return;
        setMonitoringActionLoading(true)
        stopMonitoring(+projectId).then(res => {
            setProject({
                ...project,
                working: false,
            })
            if (!!res.data) {
                message.info('监测已停止');
            }
        }).finally(() => {
            setMonitoringActionLoading(false);
        })
    }

    // 开启批量采集
    const startCollectionClick = () => {
        emitter.emit(Emit_Event.START_COLLECTION)
    }

    // 批量停止采集
    const stopCollectionClick = () => {
        emitter.emit(Emit_Event.STOP_COLLECTION)
    }

    // 测试全体设备
    const testCheckAllDevice = () => {
        setTestModalVisible(true)
        setPercent(0)
        // 获取所有设备
        let getPromises = [getSensors(Number(projectId)), getDataBoxes(Number(projectId))]
        axios.all(getPromises).then(res => {
            // 获取传感器
            let sensorList: Sensor[] = res[0]?.data || []
            // 获取采集箱
            let dataBoxList: DataBox[] = res[1]?.data || []
            let deviceNum: number = sensorList.length + dataBoxList.length
            if (deviceNum == 0) {
                return
            }
            let testTime = Date.now()
            let finishTestNum: number = 0
            // 测试采集箱连接
            for (let i = 0; i < dataBoxList.length; i++) {
                testDataBoxConnect(dataBoxList[i].id).then(res => {
                    let addHistory: DeviceTotalTestConnectHistory = {
                        testTime: testTime,
                        name: dataBoxList[i].code,
                        sensorId: null,
                        dataBoxId: dataBoxList[i].id,
                        testStatus: res.data
                    }
                    addTotalTestHistory(Number(projectId), [addHistory])
                    finishTestNum++
                    setTimeout(() => {
                        setPercent(Number(((finishTestNum / deviceNum) * 100).toFixed(1)))
                    }, 0)
                })
            }
            // 测试传感器连接
            for (let i = 0; i < sensorList.length; i++) {
                testSensorConnect(sensorList[i].id).then(res => {
                    let addHistory: DeviceTotalTestConnectHistory = {
                        testTime: testTime,
                        name: sensorList[i].code,
                        sensorId: sensorList[i].id,
                        dataBoxId: null,
                        testStatus: res.data
                    }
                    addTotalTestHistory(Number(projectId), [addHistory])
                    finishTestNum++
                    setTimeout(() => {
                        setPercent(Number(((finishTestNum / deviceNum) * 100).toFixed(1)))
                    }, 0)
                })
            }
        })
    }

    useEffect(() => {
        if (percent == 100) {
            setTestModalVisible(false)
        }
    }, [percent])

    const onClickUploadRecord = () => {
        setUploadSensor(null)
        setUploadDataBox(null)
        let editor = graphicStore?.extraContext?.getCurrentViewEditor()
        if (!editor) return
        let selectEntity = editor.selectControl.getSelectedEntityList();
        if (!(selectEntity?.length == 1)) return
        let entity = selectEntity[0]
        let promiseList = []
        // 从sensor表查询
        promiseList.push(getSensorByPrimitiveUuid(entity.uuid))
        // 从databox表查询
        promiseList.push(getDataBoxByPrimitiveUuid(entity.uuid))
        axios.all(promiseList).then(res => {
            let sensor: Sensor = res[0]?.data
            let dataBox: DataBox = res[1]?.data
            if (sensor?.id) {
                setUploadSensor(sensor)
                setUploadRecordVisible(true)
            } else if (dataBox?.id) {
                setUploadDataBox(dataBox)
                setUploadRecordVisible(true)
            }
        })
    }

    const onClickChange = () => {
        setChangeDataBox(null)
        setChangeSensor(null)
        let editor = graphicStore?.extraContext?.getCurrentViewEditor()
        if (!editor) return
        let selectEntity = editor.selectControl.getSelectedEntityList();
        if (!(selectEntity?.length == 1)) return
        let entity = selectEntity[0]
        let promiseList = []
        // 从sensor表查询
        promiseList.push(getSensorByPrimitiveUuid(entity.uuid))
        // 从databox表查询
        promiseList.push(getDataBoxByPrimitiveUuid(entity.uuid))
        axios.all(promiseList).then(res => {
            let sensor: Sensor = res[0]?.data
            let dataBox: DataBox = res[1]?.data
            if (sensor?.id) {
                setChangeSensor(sensor)
                setChangeModalVisible(true)
            } else if (dataBox?.id) {
                setChangeDataBox(dataBox)
                setChangeModalVisible(true)
            }
        })
    }


    return (
        <div className="menu-main">
            <div className="menu-item">
                <div className="title">
                    项目管理
                </div>
                <div className="menu-row">
                    <div style={{ width: "88px" }}>
                        <MenuButton name="文件" icon={<FileSvg />} onClick={() => { onMenuButtonClick("file-manager") }} />
                    </div>
                    <div style={{ width: "106px" }}>
                        <MenuButton name="发布监测数据" icon={<SendDataSvg />} onClick={() => { }} />
                    </div>
                    <div style={{ width: "88px" }}>
                        {project?.working && (
                            <MenuButton name='停止监测' icon={<Icon component={SwitchSvg} spin={monitoringActionLoading} />} onClick={() => onStopClick()} />
                        )}
                        {!project?.working && (
                            <MenuButton name='启动监测' icon={<Icon component={SwitchSvg} spin={monitoringActionLoading} />} onClick={() => onStartClick()} />
                        )}

                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "88px" }}>
                        <MenuButton name="系统日志" icon={<SystemLogSvg />} onClick={() => { onMenuButtonClick("system-log") }} />
                    </div>
                    <div style={{ width: "106px" }}>
                        <MenuButton name="发布评估结果" icon={<SendResultSvg />} onClick={() => { }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "88px" }}>
                        <MenuButton name="用户" icon={<UserManagerSvg />} onClick={() => { onMenuButtonClick("user-manager") }} />
                    </div>
                    <div style={{ width: "106px" }}>
                        <MenuButton name="监测报告" icon={<GenerateReportSvg />} onClick={() => { }} />
                    </div>
                </div>
            </div>

            <div className="division" />

            <div className="menu-item" style={{ width: "204px" }} >
                <div className="title">
                    几何
                </div>
                <div className="menu-row">
                    <div style={{ width: "64px" }}>
                        <MenuButton name="点" icon={<PointSvg />} onClick={() => { onActiveSubControl('POINT') }} />
                    </div>
                    <div style={{ width: "52px" }}>
                        <MenuButton name="圆" icon={<CircleSvg />} onClick={() => { onActiveSubControl('CIRCLE') }} />
                    </div>
                    <div style={{ width: "64px" }}>
                        <MenuButton name="拉伸体" icon={<ExtSolidSvg />} onClick={() => { onActiveSubControl('EXTRUDE') }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "64px" }}>
                        <MenuButton name="线" icon={<LineSvg />} onClick={() => { onActiveSubControl('LINE') }} />
                    </div>
                    <div style={{ width: "52px" }}>
                        <MenuButton name="矩形" icon={<RectangleSvg />} onClick={() => { onActiveSubControl('RECTANG') }} />
                    </div>
                    <div style={{ width: "64px" }}>
                        <MenuButton name="旋转体" icon={<ResolveSvg />} onClick={() => { onActiveSubControl('REVOLVE') }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "64px" }}>
                        <MenuButton name="多义线" icon={<PlineSvg />} onClick={() => { onActiveSubControl('PLINE') }} />
                    </div>
                    <div style={{ width: "52px" }}>
                        <MenuButton name="面域" icon={<RegionSvg />} onClick={() => { onActiveSubControl('REGION') }} />
                    </div>
                </div>
            </div>

            <div className="division" />

            <div className="menu-item" style={{ width: "192px" }} >
                <div className="title">
                    建模
                </div>
                <div className="menu-row">
                    <div style={{ width: "52px" }}>
                        <MenuButton name="站台" icon={<StationSvg />} onClick={() => { onMenuButtonClick("station") }} />
                    </div>
                    <div style={{ width: "64px" }}>
                        <MenuButton name="屋面板" icon={<RoofSlabSvg />} onClick={() => { onMenuButtonClick("roof-slab") }} />
                    </div>
                    <div style={{ width: "52px" }}>
                        <MenuButton name="路灯" icon={<LampSvg />} onClick={() => { onAssembleComponentClick(COMPONENT_TYPE.LAMP, LayerType.STREET_LAMP) }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "52px" }}>
                        <MenuButton name="柱" icon={<ColumnSvg />} onClick={() => { onMenuButtonClick("column") }} />
                    </div>
                    <div style={{ width: "64px" }}>
                        <MenuButton name="檐口板" icon={<EavesBoardSvg />} onClick={() => { onMenuButtonClick("eaves-board") }} />
                    </div>
                    <div style={{ width: "52px" }}>
                        <MenuButton name="组件" icon={<ComponentSvg />} onClick={() => { onMenuButtonClick("component") }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "52px" }}>
                        <MenuButton name="天沟" icon={<GutterSvg />} onClick={() => { onMenuButtonClick("gutter") }} />
                    </div>
                    <div style={{ width: "64px" }}>
                        <MenuButton name="指北针" icon={<CompassSvg />} onClick={() => { onAssembleComponentClick(COMPONENT_TYPE.COMPASS, LayerType.COMPASS) }} />
                    </div>
                    <div style={{ width: "52px" }}>
                        <MenuButton name="树" icon={<TreeSvg />} onClick={() => { onAssembleComponentClick(COMPONENT_TYPE.TREE, LayerType.TREE) }} />
                    </div>
                </div>
            </div>

            <div className="division" />

            <div className="menu-item" style={{ width: "80px" }} >
                <div className="title">
                    监测对象
                </div>
                <div className="menu-row">
                    <div style={{ width: "80px" }}>
                        <MenuButton name="选天沟" icon={<SelectGutterSvg />} onClick={() => { selectMonitorObject('SELECTGUTTERMONITOROBJECT') }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "80px" }}>
                        <MenuButton name="选屋面板" icon={<SelectRoofSlabSvg />} onClick={() => { selectMonitorObject('SELECTROOFSLAPMONITOROBJECT') }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "80px" }}>
                        <MenuButton name="定风位" icon={<SelectWindLocationSvg />} onClick={() => { selectMonitorObject('SELECTWINDLOCATIONMONITOROBJECT') }} />
                    </div>
                </div>
            </div>

            <div className="division" />

            <div className="menu-item" style={{ width: "80px" }} >
                <div className="title">
                    参数设计
                </div>
                <div className="menu-row">
                    <div style={{ width: "80px" }}>
                        <MenuButton name="预警值" icon={<WarningLevelSvg />} onClick={() => { commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_THRESHOLD}`) }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "80px" }}>
                        <MenuButton name="标定" icon={<WarningLevelSvg />} onClick={() => { commonTabbarContext.navigate(`${TAB_TYPE.CALIBRATION}`) }} />
                    </div>
                </div>
            </div>

            <div className="division" />

            <div className="menu-item" style={{ width: "376px" }} >
                <div className="title">
                    设备系统
                </div>
                <div className="menu-row">
                    <div style={{ width: "64px" }}>
                        <MenuButton name="设备表" icon={<DeviceListSvg />} onClick={() => { onMenuButtonClick("device-list") }} />
                    </div>
                    <div style={{ width: "88px" }}>
                        <MenuButton name="风速风向仪" icon={<AnemoclinographSvg />} onClick={() => { onMenuButtonClick("anemoclinograph") }} />
                    </div>
                    <div style={{ width: "88px" }}>
                        <MenuButton name="硬盘录像机" icon={<DvrSvg />} onClick={() => { onMenuButtonClick("dvr") }} />
                    </div>
                    <div style={{ width: "88px" }}>
                        <MenuButton name="传感器匹配" icon={<MatchSvg />} onClick={() => { onMenuButtonClick("param-match-sensor") }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "64px" }}>
                        <MenuButton name="工控机" icon={<IPCSvg />} onClick={() => { onMenuButtonClick("IPC-list") }} />
                    </div>
                    <div style={{ width: "88px" }}>
                        <MenuButton name="摄像头" icon={<CameraSvg />} onClick={() => { onMenuButtonClick("camera") }} />
                    </div>
                    <div style={{ width: "88px" }}>
                        <MenuButton name="串口设备" icon={<SerialSvg />} onClick={() => { onMenuButtonClick("serial-device") }} />
                    </div>
                    <div style={{ width: "88px" }}>
                        <MenuButton name="传感器选型" icon={<SensorTypeSvg />} onClick={() => { setVisiable(true) }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "64px" }}>
                        <MenuButton name="交换机" icon={<ExchangeBoardSvg />} onClick={() => { }} />
                    </div>
                    <div style={{ width: "88px" }}>
                        <MenuButton name="水位计" icon={<WaterLevelGaugeSvg />} onClick={() => { onMenuButtonClick("water-level-gauge") }} />
                    </div>
                    <div style={{ width: "88px" }}>
                        <MenuButton name="数据线" icon={<DataWireSvg />} onClick={() => { onMenuButtonClick("cable") }} />
                    </div>
                </div>
            </div>

            <div className="division" />

            <div className="menu-item" style={{ width: "80px" }} >
                <div className="title">
                    安装与测试
                </div>
                <div className="menu-row">
                    <div style={{ width: "76px" }}>
                        <MenuButton name="上传记录" icon={<UploadRecordSvg />} onClick={() => { onClickUploadRecord() }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "76px" }}>
                        <MenuButton name="测试" icon={<TestSvg />} onClick={() => { testCheckAllDevice() }} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "76px" }}>
                        <MenuButton name="测试记录" icon={<TestRecordSvg />} onClick={() => { onMenuButtonClick("test-record") }} />
                    </div>
                </div>
            </div>

            <div className="division" />

            <div className="menu-item" style={{ width: "150px" }} >
                <div className="title">
                    运维
                </div>
                <div className="menu-row">
                    <div style={{ width: "52px" }}>
                        <MenuButton name="采集" icon={<StartSvg />} onClick={() => { startCollectionClick() }} />
                    </div>
                    <div style={{ width: "76px" }}>
                        <MenuButton name="报警记录" icon={<WarningSvg />} onClick={() => commonTabbarContext.navigate(`${TAB_TYPE.WARNING}`)} />
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "52px" }}>
                        <MenuButton name="暂停" icon={<StopSvg />} onClick={() => { stopCollectionClick() }} />
                    </div>
                    <div style={{ width: "76px" }}>
                    </div>
                </div>
                <div className="menu-row">
                    <div style={{ width: "52px" }}>
                        <MenuButton name="更换" icon={<ChangeSvg />} onClick={() => { onClickChange() }} />
                    </div>
                    <div style={{ width: "76px" }}>
                    </div>
                </div>
            </div>
            <DragModal
                visible={testModalVisible}
                showHeader={false}
                wrapClassName="total-test-modal"
                width={432}
                destroyOnClose
                onClose={() => { setTestModalVisible(false) }}
            >
                <div className="test-body">
                    <div className="title">
                        <div className="name">
                            测试中
                        </div>
                        <div className="percent">
                            {percent.toString() + "%"}
                        </div>
                    </div>
                    <div className="body">
                        <div className="line">
                            <div className="active-line" style={{ width: `${(percent.toString())}%` }} />
                        </div>
                    </div>
                    <div className="btn" onClick={() => { setTestModalVisible(false) }}>
                        取消
                    </div>
                </div>
            </DragModal>

            <DragModal
                visible={uploadRecordVisible}
                showHeader={false}
                width={788}
                onClose={() => { setUploadRecordVisible(false) }}
                wrapClassName="upload-record-modal"
            >
                <UploadRecordModal sensor={uploadSensor} dataBox={uploadDataBox} setVisible={setUploadRecordVisible} />
            </DragModal>

            <DragModal
                visible={changeModalVisible}
                showHeader={false}
                width={788}
                onClose={() => { setChangeModalVisible(false) }}
                wrapClassName="change-modal"
            >
                <ReplaceModal sensor={changeSensor} dataBox={changeDataBox} setVisible={setChangeModalVisible} />
            </DragModal>

            {visiable && <AddSensorMarkingModal visible={visiable} setVisible={setVisiable} />}
        </div>
    )
}